import { useMemo } from 'react';

import { Maybe } from '../../types';
import {
  IntersessionSummary__FollowUpPreVisitSummaryContent,
  IntersessionSummary__IntakePreVisitSummaryContent,
  IntersessionSummary__PreVisitSummary,
} from './types';

function isFollowUpContent(
  content: IntersessionSummary__PreVisitSummary['content'],
): content is IntersessionSummary__FollowUpPreVisitSummaryContent {
  return content?.__typename === 'FollowUpPreVisitSummaryContentObject';
}

type ContentData = {
  isFollowUp: boolean;
  coachTopics: string[];
  completedResources: string[];
  reflectionTopics: string[];
  numCompletedResources: number;
};

export function useFormatContentData(
  content:
    | Maybe<IntersessionSummary__IntakePreVisitSummaryContent | IntersessionSummary__FollowUpPreVisitSummaryContent>
    | undefined,
): ContentData {
  return useMemo(() => {
    const isFollowUp = isFollowUpContent(content);
    const coachTopics = content?.generatedCoachTopics || [];
    const completedResources = isFollowUp ? content?.completedResources || [] : [];
    const reflectionTopics = isFollowUp ? content?.reflectionTopics || [] : [];

    return {
      isFollowUp,
      coachTopics,
      completedResources,
      reflectionTopics,
      numCompletedResources: completedResources.length,
    };
  }, [content]);
}
